import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from 'vuetify/lib/locale/en'
import de from 'vuetify/lib/locale/de'

Vue.use(VueI18n)

const messages = {
  de: {
    api: {
    ...require('@/locales/de_api.json')
    },
    ...require('@/locales/de.json'),
    $vuetify: de,
  },
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
  },
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'de',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
  messages,
})
